export const coursesData = [
  {
    id: 1,
    title: "React de Cero a Experto: Hooks y Context",
    category: "Frontend",
    image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?q=80&w=2070",
    instructor: "Adrian Flores",
    description: "Domina la librería más popular de JavaScript. Aprende a crear aplicaciones modernas.",
    rating: 4.9,
    featured: true,
    chapters: [
      { id: 1, title: "Introducción a React 19", duration: "12:00", videoUrl: "https://www.youtube.com/embed/7iobxzd_2wY" },
      { id: 2, title: "Hooks Esenciales", duration: "15:45", videoUrl: "https://www.youtube.com/embed/L72fhGm1tfE" }
    ]
  },
  {
    id: 2,
    title: "Sistemas de Diseño con Tailwind CSS",
    category: "Frontend",
    image: "https://images.unsplash.com/photo-1587620962725-abab7fe55159?q=80&w=2062",
    instructor: "Elena Ruiz",
    description: "Aprende a construir interfaces consistentes y profesionales con Tailwind.",
    rating: 4.8,
    featured: false,
    chapters: [{ id: 1, title: "Instalación y Configuración", duration: "08:20", videoUrl: "https://www.youtube.com/embed/lCxcTsOHrjo" }]
  },
  {
    id: 3,
    title: "Backend Pro: Node.js y PostgreSQL",
    category: "Backend",
    image: "https://images.unsplash.com/photo-1627398242454-45a1465c2479?q=80&w=1974",
    instructor: "Marcos Tech",
    description: "Construye APIs robustas con bases de datos relacionales.",
    rating: 4.7,
    featured: true,
    chapters: [{ id: 1, title: "Docker y Bases de Datos", duration: "25:00", videoUrl: "https://www.youtube.com/embed/0SJE9dYdpps" }]
  },
  {
    id: 4,
    title: "Prompt Engineering para Desarrolladores",
    category: "Data Science",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=2070",
    instructor: "Dr. Sam Altman",
    description: "Cómo utilizar LLMs para acelerar tu flujo de trabajo.",
    rating: 5.0,
    featured: true,
    chapters: [{ id: 1, title: "Lógica de Prompts", duration: "15:00", videoUrl: "https://www.youtube.com/embed/mEjO_fT8jH8" }]
  },


  {
    id: 5,
    title: "Ciberseguridad: Ethical Hacking desde Cero",
    category: "Ciberseguridad",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=2070",
    instructor: "Javier Cyber",
    description: "Aprende las técnicas de los profesionales para proteger infraestructuras y detectar vulnerabilidades.",
    rating: 4.9,
    featured: true,
    chapters: [
      { id: 1, title: "Introducción al Pentesting", duration: "18:20", videoUrl: "https://www.youtube.com/embed/3Kq1MIfTWCE" },
      { id: 2, title: "Escaneo de Redes con Nmap", duration: "22:15", videoUrl: "https://www.youtube.com/embed/4S9S6Dlh9_E" }
    ]
  },
  {
    id: 6,
    title: "Diseño UX/UI Pro: De Figma al Código",
    category: "Diseño",
    image: "https://images.unsplash.com/photo-1586717791821-3f44a563cc4c?q=80&w=2070",
    instructor: "Laura UI",
    description: "Domina Figma para crear interfaces modernas y aprende a preparar tus assets para desarrollo.",
    rating: 4.8,
    featured: false,
    chapters: [{ id: 1, title: "Sistemas de Diseño en Figma", duration: "15:30", videoUrl: "https://www.youtube.com/embed/jk1T6baJz2M" }]
  },
  {
    id: 7,
    title: "Masterclass de Docker y Kubernetes",
    category: "DevOps",
    image: "https://images.unsplash.com/photo-1605745341112-85968b193ef1?q=80&w=2070",
    instructor: "David Ops",
    description: "Despliega aplicaciones a gran escala utilizando contenedores y orquestadores líderes.",
    rating: 5.0,
    featured: true,
    chapters: [{ id: 1, title: "Fundamentos de Contenedores", duration: "14:10", videoUrl: "https://www.youtube.com/embed/4Dko5W96WHg" }]
  },
  {
    id: 8,
    title: "Desarrollo de Apps con Flutter",
    category: "Mobile",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?q=80&w=2070",
    instructor: "Sofia Dev",
    description: "Crea aplicaciones nativas para iOS y Android con una sola base de código.",
    rating: 4.7,
    featured: false,
    chapters: [{ id: 1, title: "Widgets y Estados", duration: "19:45", videoUrl: "https://www.youtube.com/embed/pTJJsmejUOQ" }]
  },
  {
    id: 9,
    title: "Analítica de Datos con SQL y Tableau",
    category: "Data Science",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070",
    instructor: "Marcos Data",
    description: "Transforma datos crudos en visualizaciones interactivas que cuenten una historia.",
    rating: 4.9,
    featured: false,
    chapters: [{ id: 1, title: "Consultas Avanzadas en SQL", duration: "21:00", videoUrl: "https://www.youtube.com/embed/7VZHf9qL_Gk" }]
  },
  {
    id: 10,
    title: "Web3: Desarrollo de Smart Contracts",
    category: "Blockchain",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?q=80&w=2070",
    instructor: "Blockchain Master",
    description: "Escribe tus primeros contratos inteligentes usando Solidity y despliégalos en Ethereum.",
    rating: 4.6,
    featured: true,
    chapters: [{ id: 1, title: "Introducción a Solidity", duration: "25:30", videoUrl: "https://www.youtube.com/embed/M576WGiDBdQ" }]
  }
];